<div class="container container-responsive">
  @if (applications.length > 0) {
  <av-card [backdrop]="false" class="apps">
    <av-card-header>
      <span translate>Choose your integration</span>
    </av-card-header>
    <av-card-body>
      <av-menu>
        @for (a of applications; track a) {
        <av-menu-item (click)="pickInstance(a)">
          {{ a.instance.name }}
        </av-menu-item>
        }
      </av-menu>
    </av-card-body>
  </av-card>
  }
</div>
